import { render, staticRenderFns } from "./permanent_deletion_confirm_checkbox.vue.js?vue&type=template&id=9d757ba6&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./permanent_deletion_confirm_checkbox.vue?vue&type=template&id=9d757ba6&vue3"
import script from "./permanent_deletion_confirm_checkbox.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./permanent_deletion_confirm_checkbox.vue?vue&type=script&lang=js&vue3"
export * from "./permanent_deletion_confirm_checkbox.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./permanent_deletion_confirm_checkbox.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports